export const phoneValidator = (phone: string): boolean => phone?.length >= 1 && phone?.length <= 20;

export function phoneAndPrefixValidator(phone: string | null | undefined): boolean {
  if (!phone || !phoneValidator(phone)) {
    return false;
  }
  const split = splitPhoneDigits(phone, 1);
  return !!split && split.length > 4 && /\d/.test(phone);
}

export function splitPhoneDigits(value: string, direction: number): string | undefined {
  return value?.split(' ')[direction];
}
